export function formatMoney(value) {
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Number(value || 0))
}

export function formatPct(value) {
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(Number(value || 0))
}

export function getHeatColor(intensity) {
  if (intensity === "HIGH") return "#dc2626"
  if (intensity === "MEDIUM") return "#f59e0b"
  if (intensity === "LOW") return "#16a34a"
  return "#cbd5e1"
}

export function getSatColor(level) {
  if (level === "SATURATED") return "#dc2626"
  if (level === "HIGH") return "#f59e0b"
  if (level === "LOW") return "#0ea5e9"
  if (level === "OUT_OF_SCHEDULE") return "#7c3aed"
  return "#22c55e"
}

export function getSatBg(level) {
  if (level === "SATURATED") return "#fee2e2"
  if (level === "HIGH") return "#fef3c7"
  if (level === "LOW") return "#e0f2fe"
  if (level === "OUT_OF_SCHEDULE") return "#f3e8ff"
  return "#dcfce7"
}

export function getSatLabel(level) {
  if (level === "OUT_OF_SCHEDULE") return "Fuera de horario"
  if (level === "SATURATED") return "Saturado"
  if (level === "HIGH") return "Alta presión"
  if (level === "LOW") return "Baja carga"
  return "Normal"
}

export function getScoreBadge(status) {
  if (status === "CRITICAL") {
    return {
      color: "#991b1b",
      background: "#fef2f2",
      border: "#fecaca",
      label: "Crítica"
    }
  }

  if (status === "WARNING") {
    return {
      color: "#92400e",
      background: "#fffbeb",
      border: "#fde68a",
      label: "Atención"
    }
  }

  return {
    color: "#166534",
    background: "#f0fdf4",
    border: "#bbf7d0",
    label: "Sana"
  }
}

export function getActionCardStyle(level) {
  if (level === "HIGH") {
    return {
      border: "1px solid #fecaca",
      background: "#fef2f2",
      color: "#991b1b"
    }
  }

  if (level === "MEDIUM") {
    return {
      border: "1px solid #fde68a",
      background: "#fffbeb",
      color: "#92400e"
    }
  }

  return {
    border: "1px solid #bfdbfe",
    background: "#eff6ff",
    color: "#1d4ed8"
  }
}